export default "__VITE_ASSET__BHsD19u6__"